import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';


@Component({
  selector: 'app-group-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})

export class SelectComponent implements OnInit {

  groups: any = [];
  @Input() selected_groups: any = [];
  @Input() url = "";

  @Input() local_only = false;
  @Input() current_groups: any = [];



  roles: any = [];
  add_group = {
    title: '',
    colour: '#90ee90'
  }


  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let data: any = null;
    if(!this.local_only) {
      data = await this.apiService.GetGroups(this.url);
      this.groups = data.data;
    } else {
      this.groups = this.current_groups;
    }
    var group_title = this.add_group.title;
    this.groups.forEach(group => {
      if(group.title === group_title) this.selected_groups.push(group);
    });
    this.selected_groups.forEach(group => {
      var index = this.groups.findIndex(function(item, i){return item.guid === group.guid});
      if(index >= 0)
        this.groups.splice(index,1);
    });
  }

  async Update() {
    this.modalController.dismiss(this.selected_groups);
  }
  async Cancel() {
    this.modalController.dismiss(null);
  }

  async CreateGroup() {
    if(this.local_only) {
      let new_group = {
        guid: this.globalService.createGUID(),
        title: this.add_group.title,
        colour: this.add_group.colour
      };
      this.current_groups = [...this.current_groups, new_group];
      await this.GetData();
    }
    else{
      this.globalService.presentLoading('Creating group...', 99999999);
      let data: any = await this.apiService.post(`groups/${this.url}`,this.add_group);
      this.globalService.dismissLoading();
    this.globalService.presentToastMessage(data.message,data.success);
    await this.GetData();
    }
    
    this.add_group.title = '';
  }

}

